import React from "react";

const ModalBody = ({ children, bodyClass = "" }) => {
  return <div className={`modal-body ${bodyClass}`}>{children}</div>;
};

export default ModalBody;
